import { scoreConstants } from '../constants'

export const scoreLoad = (payload) => {
  return {
    type: scoreConstants.SCORE_LOAD,
    payload
  }
}

export const scoreLoadSuccess = (payload) => {
  return {
    type: scoreConstants.SCORE_LOAD_SUCCESS,
    payload
  }
}

export const scoreLoadFailure = (payload) => {
  return {
    type: scoreConstants.SCORE_LOAD_FAILURE,
    payload
  }
}

export const scoreReset = () => {
  return {
    type: scoreConstants.SCORE_RESET
  }
}

export const scoreSave = (payload) => {
  return {
    type: scoreConstants.SCORE_SAVE,
    payload
  }
}

export const scoreSaveSuccess = (payload) => {
  return {
    type: scoreConstants.SCORE_SAVE_SUCCESS,
    payload
  }
}

export const scoreSaveFailure = (payload) => {
  return {
    type: scoreConstants.SCORE_SAVE_FAILURE,
    payload
  }
}
